import React, { useCallback, useState } from "react";
import { Panel, useReactFlow } from "reactflow";
import { toJpeg, toPng } from "html-to-image";
import {jsPDF} from "jspdf";
import { autoTable } from 'jspdf-autotable'
import getHongKongTimestamp from "../utils/getHongKongTime";
import { toast } from "react-toastify";

const nodeWidth = 450;
const nodeHeight = 250;



const DownloadButton = React.memo(({ style, onDownload , isExporting}) => {




  return (
    <Panel stlye={{ style }}>
      <button
        style={{
          top: "7px",
          left: "190px",
          transform: "translateY(0%)",
          // zIndex: 10000,
          pointerEvents: "auto",
          opacity: isExporting ? 0.6 : 1,
          cursor: isExporting ? "wait" : "pointer",
        }}
        className="btn btn-outline-primary position-absolute"
        onClick={onDownload}
        disabled={isExporting}
      >
        {isExporting ? "Exporting..." : "Download"}
      </button>
    </Panel>
  );
});

export default DownloadButton;
